(function () {
  initializeUtilsFunctions();
  executeOnce('offer-page', function () {

    function onClickOfferSelect() {
      if(document.querySelector('.offer-page')){
        const btns = document.querySelector('.offer-page').querySelectorAll('.btn-select-offer');
        if(btns && btns.length > 0){
          btns.forEach(b=> {
            b.addEventListener('click', (e) => {
              if(!e.currentTarget.classList.contains('active')) {
                document.querySelector('.offer-page').querySelectorAll('.btn-select-offer').forEach(btn => btn.classList.remove('active'));
                e.currentTarget.classList.add('active');
                document.querySelector('.form-lead').querySelector('.step-1').querySelector('.model').querySelector('.car').innerHTML = e.currentTarget.parentNode.querySelector('.offer--title').innerText;
                document.querySelector('.form-lead').querySelector('.car').querySelector('.model').innerHTML = e.currentTarget.parentNode.querySelector('.offer--title').innerText;
                document.querySelector('.form-lead').setAttribute('data-promo-id', e.currentTarget.parentNode.getAttribute('data-value'));
                document.querySelector('.form-lead').setAttribute('data-promo-name', e.currentTarget.parentNode.querySelector('.offer--title').getAttribute('data-promo-name'));
                document.querySelector('.form-lead').setAttribute('data-push',  e.currentTarget.parentNode.getAttribute('data-push'));
                document.querySelector('.form-lead').classList.remove('fly');
                document.querySelector('.form-lead').querySelector('.form-content').classList.remove('active');
                document.querySelector('.form-lead').setAttribute('data-offer-purpose-name', e.currentTarget.parentNode.getAttribute('data-offer-purpose'));
                document.querySelector('.form-lead').setAttribute('data-rental-operator-name', e.currentTarget.parentNode.getAttribute('data-rental-operator'));
                document.querySelector('.form-lead').setAttribute('data-promo-name', e.currentTarget.parentNode.querySelector('.offer--title').getAttribute('data-promo-name'));
                document.querySelector(".dynamic-offer-title").textContent = e.currentTarget.parentNode.getAttribute('data-offer-header-title');

                analyticsOffer.offerTitle = e.currentTarget.parentNode.querySelector('.offer--title').innerText;
                analyticsOffer.offerId = e.currentTarget.parentNode.getAttribute('data-value');
                analyticsOffer.push = e.currentTarget.parentNode.getAttribute('data-push');
                const form_disabled = e.currentTarget.parentNode.getAttribute('data-offer-form-disabled');
                const offer_hidden_form = document.querySelector('.form-lead').querySelector(".hide-form.offer-form");
                if (form_disabled === "On" && offer_hidden_form) {
                  offer_hidden_form.classList.remove("hide");
                  document.querySelector('.form-lead').querySelector(".form-visible").classList.add("hide");
                } else if (offer_hidden_form) {
                  offer_hidden_form.classList.add("hide");
                  document.querySelector('.form-lead').querySelector(".form-visible").classList.remove("hide");
                  getPrivacyForm();
                }

                if (e.currentTarget.parentNode.hasAttribute('data-variation-id') && e.currentTarget.parentNode.hasAttribute('data-variation-name')){
                  document.querySelector('.form-lead').setAttribute('data-variation-id', e.currentTarget.parentNode.getAttribute('data-variation-id'));
                  document.querySelector('.form-lead').setAttribute('data-variation-name', e.currentTarget.parentNode.getAttribute('data-variation-name'));
                } else {
                  document.querySelector('.form-lead').removeAttribute('data-variation-id');
                  document.querySelector('.form-lead').removeAttribute('data-variation-name');
                }

              } else {
               if( document.querySelector('.form-lead')){
                 startBasketCriteo();
                 document.querySelector('.form-lead').classList.add('fly');
                 document.querySelector('.form-lead').querySelector('.form-content').classList.add('active');
               }
              }
            })
          })
        }
      }
    }

    function addClickOnOfferInfo(item, btn) {
      const infos = item.querySelectorAll('.offer--info');
        btn.addEventListener('click', function (e) {
          btn.checkActive = true;
          infos.forEach(function (info) {
            info.classList.toggle('active');
            e.target.classList.toggle('active');
          });
        });

    }

    function getOffersPage() {
      const offers = document.querySelectorAll('.offer');
      if (offers) {
        offers.forEach(function (offer) {
          const infoBtns = offer.querySelectorAll('.offer--more-info');
          infoBtns.forEach(function (item, index) {
            item.classList.add('offer--more-info-' + index);
            const infos = offer.querySelectorAll('.offer--info');
            infos.forEach(function (info) {
              info.classList.add('offer--info-' + index);
            });
            addClickOnOfferInfo(offer, item);
            window.addEventListener('resize', (e) => {
              const infos = offer.querySelectorAll('.offer--info:not(.no-reset)');
              item.classList.remove('active');
              infos.forEach(function (info) {
                info.classList.remove('active');
              });
            })
          });

        });
      }
    }

    getOffersPage();
    onClickOfferSelect()
  });
}());


